import { render, staticRenderFns } from "./newMaterialAssess.vue?vue&type=template&id=416fdbd1&scoped=true&"
import script from "./newMaterialAssess.vue?vue&type=script&lang=js&"
export * from "./newMaterialAssess.vue?vue&type=script&lang=js&"
import style0 from "./newMaterialAssess.vue?vue&type=style&index=0&id=416fdbd1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416fdbd1",
  null
  
)

component.options.__file = "newMaterialAssess.vue"
export default component.exports